export default {
  title: {
    id: 'create_shipping_label_page_title',
    defaultMessage: 'Create Shipping Label',
  },
  description: {
    id: 'create_shipping_label_page_description',
    defaultMessage: 'Create Shipping Label',
  },
  prompt: {
    id: 'create_shipping_label_title',
    defaultMessage: 'To which address would you like to receive your order?',
  },
  successTitle: {
    id: 'create_shipping_label_success_title',
    defaultMessage: 'Well done!',
  },
  successMessage: {
    id: 'create_shipping_label_success_message',
    defaultMessage:
      'Your label is being generated. You will receive it within a few minutes in your notifications.',
  },
  errorTitle: {
    id: 'create_shipping_label_error_title',
    defaultMessage: 'Oops!',
  },
  errorMessage: {
    id: 'create_shipping_label_error_message',
    defaultMessage:
      'Your label could not be generated. Please check the information provided or contact transport@backmarket.com.',
  },
  closeToast: {
    id: 'create_shipping_label_close_toast',
    defaultMessage: 'Close the toast',
  },
  shipper: {
    id: 'create_shipping_label_carrier_label',
    defaultMessage: 'Carrier',
  },
  orderId: {
    id: 'create_shipping_label_label_order_id',
    defaultMessage: 'Order ID',
  },
  selectOrder: {
    id: 'create_shipping_label_label_select_order',
    defaultMessage: 'Select order',
  },
  orderAutoFillInformation: {
    id: 'create_shipping_label_order_autofill_information',
    defaultMessage:
      'Enter the order number to auto-fill the details. Don’t worry, you can make changes at any point.',
  },
  shippingDetails: {
    id: 'create_shipping_label_label_shipping_details',
    defaultMessage: 'Shipping details',
  },
  buttonSubmit: {
    id: 'create_shipping_label_button_submit',
    defaultMessage: 'Generate shipping label',
  },
  loadingForm: {
    id: 'create_shipping_label_loading_form',
    defaultMessage: 'Preparing the shipping label form...',
  },
  required: {
    id: 'create_shipping_label_required',
    defaultMessage: 'This field is required!',
  },
  companyLabel: {
    id: 'create_shipping_label_required_company',
    defaultMessage: 'Company',
  },
  orderNotFound: {
    id: 'create_shipping_label-not_found',
    defaultMessage:
      'We can’t find this order. Please double-check and try again.',
  },
  genericErrorMessage: {
    id: 'create_shipping_label-generic_error_message',
    defaultMessage: 'An error occured',
  },
} as const
